import { Component, OnDestroy } from '@angular/core';
import { UserSkillHistory } from '@mira-avant/mtlibs';
import { SkillService } from '../../../../services/skill.service';
import { AdminService } from '../../../../services/admin.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

@Component({
	selector: 'app-user-skill-history',
	standalone: true,
	imports: [CommonModule, NzTableModule, NzTypographyModule],
	templateUrl: './user-skill-history.component.html',
	styleUrl: './user-skill-history.component.scss',
})
export class UserSkillHistoryComponent implements OnDestroy {
	public userSkillHistory: UserSkillHistory[] = [];
	public selectedUserCognitoUuid?: string;
	private subscriptions: Subscription = new Subscription();

	constructor(
		public adminService: AdminService,
		public skillService: SkillService
	) {
		// Subscribe to user skill history
		this.subscriptions.add(
			this.skillService.userSkillHistory$.subscribe(history => {
				this.userSkillHistory = history;
			})
		);

		// Subscribe to selected user
		this.subscriptions.add(
			this.adminService.selectedUser$.subscribe(user => {
				this.selectedUserCognitoUuid = user?.uuid;
				if (user?.uuid) {
					// Fetch user skill history using uuid (treated as cognito_uuid)
					this.skillService.getUserSkillHistory$(user.uuid).catch(error => {
						console.error('Error fetching user skill history:', error);
					});
				} else {
					// Clear history when no user is selected
					this.userSkillHistory = [];
				}
			})
		);
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
